import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import { graphql } from 'react-apollo';
import cx from 'classnames';

import PromoCodeList from '../../../../components/SiteAdmin/PromoCode/PromoCodeList';
import Loader from '../../../../components/Common/Loader/Loader';

import getAllPromoCodeQuery from './getAllPromoCode.graphql';
import messages from '../../../../locale/messages';

import s from './PromoCode.css';

class PromoCode extends React.Component {

  static defaultProps = { promoCodes: { loading: true } };

  render() {
    const { promoCodes, promoCodes: { loading }, intl: { formatMessage } } = this.props;
    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          {!loading && <div className={s.container}>
            <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>  {formatMessage(messages.managePromoCode)}</div>
            <div className={s.paddingRoutesSection}>
              <PromoCodeList promoCodes={promoCodes} />
            </div>
          </div>}
        </div>
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  graphql(getAllPromoCodeQuery, {
    name: 'promoCodes',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1
      }
    }
  }))(PromoCode);
